import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";

export default function AboutUs() {
  return (
    <React.Fragment>
      <div className="main main-about-legacy p-0">
        <div className="py-5 mb-5 about-legacy-hero">
          <Container className="py-5 text-center">
            <h1 className="display-5 fw-bold mb-4">
              금융데이터 노이즈를 걷어내고,
              <br />
              투자 본질을 연결하는 
              <br />
              ‘구루위스퍼’
            </h1>
            <p className="lead mx-auto about-legacy-hero-text about-legacy-hero-lead">
              “금융 정보는 많아졌지만, 왜 우리는 아무런 인사이트가 없을까요?”
              <br />
              구루위스퍼는 누구나 전문가 수준의 인사이트를 가질 수 있도록 금융 정보 상향 평준화를 꿈꾸고 있습니다.
            </p>
          </Container>
        </div>

        <Container className="pb-5">
          <div className="about-legacy-section about-legacy-part1 mb-5">
            <Badge bg="primary" className="mb-2 fs-6 px-3 py-2">
              Part 1
            </Badge>
            <h3 className="fw-bold mb-3">우리가 집중하는 문제: 정보는 많지만 '인사이트'는 부족한 현실</h3>
            <p className="text-secondary fs-5 mb-3">
              주식 투자를 하는 사람이라면 누구나 한 번쯤 느꼈을 답답함이 있습니다.
            </p>
            <p className="text-secondary fs-5 mb-3"><span className="fst-italic">"공시는 떴는데, 그래서 내 주식에 어떤 영향을 미친다는 거지?"</span></p>
            <p className="text-secondary">
              미국 투자 환경은 계량화된 정보와 다양한 금융 상품이 잘 갖춰져 있지만, 국내 투자자들에게는 여전히 먼 나라 이야기입니다. 
              SEC(미국 증권거래위원회)의 13F 공시나 글로벌 투자 대가들의 포트폴리오 변화를 실시간으로 분석해 내 투자에 적용하는 것은 개인에게 불가능에 가까운 영역이었죠.
              <br />
              구루위스퍼는 단순히 데이터를 전달하는 '메신저'가 아닙니다. 방대한 데이터 사이에서{" "}
              <strong className="text-dark">통계적 유의성을 가진 핵심 정보만을 추출하는 '필터'이자 '해석기'</strong>의 역할을 자처합니다.
            </p>
          </div>

          <div className="about-legacy-section mb-5">
            <div className="text-center mb-4">
              <Badge bg="primary" className="mb-2 fs-6 px-3 py-2">
                Part 2
              </Badge>
              <h3 className="fw-bold">구루위스퍼만의 해결 방식</h3>
              <p className="text-secondary">데이터 사이언스와 신호 처리의 결합</p>
            </div>
            <Row className="g-4">
              <Col md={6} lg={3}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body className="p-4">
                    <div className="mb-3 text-primary">
                      <i className="ri-database-2-line fs-2"></i>
                    </div>
                    <Card.Title className="fw-bold">Develop (Data Collection)</Card.Title>
                    <Card.Text className="text-secondary small">
                      미국 금융 시장의 수만 가지 지표와 공시 정보를 수집합니다. 언어의 장벽을 기술로 허물고, 파편화된 데이터를 하나의 체계적인 데이터베이스로 구축합니다.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} lg={3}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body className="p-4">
                    <div className="mb-3 text-primary">
                      <i className="ri-database-2-line fs-2"></i>
                    </div>
                    <Card.Title className="fw-bold">Analyze (Big Data & AI)</Card.Title>
                    <Card.Text className="text-secondary small">
                      수집된 데이터 중 ‘이상치’를 탐지하고 유의미한 상관관계를 분석합니다. 여기서 인공지능은 단순한 번역기가 아니라, 데이터의 통계적 유의성을 검증하는 고도화된 분석 도구로 작동합니다.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} lg={3}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body className="p-4">
                    <div className="mb-3 text-primary">
                      <i className="ri-line-chart-line fs-2"></i>
                    </div>
                    <Card.Title className="fw-bold">Track (Backtesting)</Card.Title>
                    <Card.Text className="text-secondary small">
                      저명한 금융 논문과 학술지에 기반한 큐레이션 종목과 글로벌 기관 투자자들의 실제 보유 종목의 수익률을 실시간으로 추적(Tracking)합니다. 이론이 실제 시장에서 어떻게 작동하는지 데이터로 증명합니다.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} lg={3}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body className="p-4">
                    <div className="mb-3 text-primary">
                      <i className="ri-apps-line fs-2"></i>
                    </div>
                    <Card.Title className="fw-bold">Adopt (Productizing)</Card.Title>
                    <Card.Text className="text-secondary small">
                      작은 공시 한줄로부터 과거의 긴 역사 속에서 어떤 '사건의 지평선'을 갖는지 찾을 수 있습니다. 당신의 투자 포트폴리오 구성에 실질적인 도움을 줄 수 있도록 쉽고 직관적인 인사이트를 제공합니다. 
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>

          <hr className="my-5 opacity-10" />

          <Row className="g-5 mb-5">
            <Col lg={6}>
              <div className="about-legacy-section h-100">
                <Badge bg="primary" className="mb-2 fs-6 px-3 py-2">
                  Part 3
                </Badge>
                <h3 className="fw-bold mb-3">팀 문화와 기업의 가치</h3>
                <h5 className="fw-bold mb-3 about-legacy-subtitle">“엔지니어링과 금융의 교집합”</h5>
                
                <ul className="list-unstyled mb-0">
                  <li className="d-flex">
                    <i className="ri-check-double-line text-primary me-2 mt-1"></i>
                    <div>
                      <strong>
                      최우선 가치는 ‘데이터의 유용성’
                      </strong>
                      <p className="text-secondary">구루위스퍼는 정답을 찾을 때까지 파고드는 집요함을 바탕으로, 금융 도메인 지식과 기술 역량의 결합이 가장 큰 임팩트를 만든다고 믿습니다.
                        금융·법률·회계·리스크 등 다양한 분야의 전문가들이 함께하며, 직군과 역할을 넘어 ‘데이터의 유용성’을 최우선 가치로 둡니다.</p>
                    </div>
                  </li>
                  <li className="mb-3 d-flex">
                    <i className="ri-check-double-line text-primary me-2 mt-1"></i>
                    <div>
                      <strong>분석은 AI, 투자의 결정은 당신</strong>
                      <p className="text-secondary">최고의 연구기관과 학술 논문에서 제안된 투자 기법들을 낱낱히 뒤져서, 혹은 우리가 직접 한땀 한땀 테스트 한 결과들을 공유합니다.
                      투자의 결정은 온전히 당신의 손에 의해 이루어져야 하며, AI 기술은 '분석'의 분야에 사용해야 한다는 것이 구루위스퍼의 생각입니다. </p>
                    </div>
                  </li>
                </ul>
            
              </div>
            </Col>
            <Col lg={6}>
              <div className="about-legacy-section h-100">
                <Badge bg="primary" className="mb-2 fs-6 px-3 py-2">
                  Part 4
                </Badge>
                <h3 className="fw-bold mb-3">신뢰성 있는 투자콘텐츠 협업</h3>
                <h5 className="fw-bold mb-3 about-legacy-subtitle">“유명증권사들이 선택한 금융 콘텐츠 서비스”</h5>
                <ul className="list-unstyled mb-0">
                  <li className="mb-3 d-flex">
                    <i className="ri-check-double-line text-primary me-2 mt-1"></i>
                    <div>
                      <strong>KB증권 ‘글로벌 투자대가 서비스’</strong>
                      <p className="text-secondary small mb-0">
                        미국 13F 공시를 분석해 워런 버핏 같은 대가들의 포트폴리오를 실시간 분석하고, 공시 다음날 TOP10 종목을 따라서 사면 어느정도의 수익이 발생하는지 분석합니다.
                      </p>
                    </div>
                  </li>
                  <li className="mb-3 d-flex">
                    <i className="ri-check-double-line text-primary me-2 mt-1"></i>
                    <div>
                      <strong>우리투자증권 ‘미국공시정보서비스’</strong>
                      <p className="text-secondary small mb-0">
                        미국증권감독위원회에서 제공하고 있는 정형/비정형 공시를 거대한 빅데이터로 만들고, 통계적 특성을 분석한 큐레이션 서비스를 제공합니다.
                      </p>
                    </div>
                  </li>
                  <li className="mb-3 d-flex">
                    <i className="ri-check-double-line text-primary me-2 mt-1"></i>
                    <div>
                      <strong>IBK투자증권 ‘공시 AI 인사이트’</strong>
                      <p className="text-secondary small mb-0">
                        금융감독원 전자공시를 알고리즘으로 분석하여, 투자자가 즉각적으로 이해할 수 있는 핵심 키워드 중심의 정보를 제공합니다.
                      </p>
                    </div>
                  </li>
                  <li className="mb-3 d-flex">
                    <i className="ri-award-line text-primary me-2 mt-1"></i>
                    <div>
                      <strong>수상 성과</strong>
                      <p className="text-secondary small mb-0">
                        2023년 중소벤처기업부 ‘혁신창업스쿨 딥테크 트랙’에서 최우수상을 수상하며, 금융 포트폴리오 플랫폼으로서의 가치를 인정받았습니다.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>

          <div className="about-legacy-section about-legacy-vision p-5 mb-5">
            <Row className="align-items-center">
              <Col lg={8}>
                <Badge bg="primary" className="mb-2 fs-6 px-3 py-2">
                  Part 5
                </Badge>
                <h3 className="fw-bold mb-3">Vision : “So What?”에 답할 수 있는 유일한 솔루션</h3>
                <p className="text-secondary mb-0">
                  우리의 미래는 명확합니다. 투자자가 수많은 정보 속에서 방황하지 않고 <strong>“그래서 내가 지금 무엇을 해야 하는가?”</strong>에 대한 답을 데이터 기반으로 얻을 수 있게 만드는 것입니다.
                  <br />
                  구루위스퍼는 앞으로 데이터 플랫폼을 넘어, 개인 맞춤형 인텔리전스 서비스로 확장하고자 합니다. 해외 리서치 페이퍼가 나의 포트폴리오에 맞춰 요약되고, 거시 경제의 변화가 내 자산에 미칠 영향을 개인화된 언어로 설명받는 시대. 구루위스퍼가 만들고 있는 투자의 미래입니다.
                </p>
              </Col>
              <Col lg={4} className="text-lg-end mt-4 mt-lg-0">
                <i className="ri-lightbulb-line text-warning display-1 opacity-25"></i>
              </Col>
            </Row>
          </div>

          <div className="text-center py-4 about-legacy-contact">
            <h4 className="fw-bold mb-3">금융 투자의 미래를 혁신하고 싶다면</h4>
            <p className="text-secondary mb-4">
              우리는 기술이 금융의 장벽을 낮추고, 모두에게 공평한 기회를 줄 수 있다고 믿는 동료를 기다립니다.
            </p>
            <div className="d-flex justify-content-center gap-4 flex-wrap">
              <div className="d-flex align-items-center text-secondary">
                <i className="ri-map-pin-line me-2"></i> 서울시 영등포구 여의대방로 83 오투타워(서울핀테크랩)
              </div>
              <div className="d-flex align-items-center text-secondary">
                <i className="ri-mail-send-line me-2"></i> junsung.lim@guruwhisper.com
              </div>
              <div className="d-flex align-items-center text-secondary">
                <i className="ri-global-line me-2"></i> www.guruwhisper.com
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}
